module.exports = __webpack_public_path__ + "img/bituah_leumi_reduced.d2a6309a.png";